<template>
  <div>
    <form v-if="user !== null" @submit.prevent="save">
      <div class="form-group">
        <label for="first-name">First name</label>
        <input id="first-name" v-model="user.firstName" class="form-control" maxlength="100" required v-focus>
      </div>

      <div class="form-group">
        <label for="last-name">Last name</label>
        <input id="last-name" v-model="user.lastName" class="form-control" maxlength="100" required>
      </div>

      <div class="form-group">
        <label for="login">Login</label>
        <input id="login" v-model="user.login" class="form-control" maxlength="30" required>
      </div>

      <div class="form-group">
        <label for="role-selector">Role</label>
        <select id="role-selector" v-model="user.role" class="form-control" required>
          <option :value="ROLE_ADMIN">{{ROLE_ADMIN | getRoleName}}</option>
          <option :value="ROLE_MODERATOR">{{ROLE_MODERATOR | getRoleName}}</option>
          <option :value="ROLE_READER">{{ROLE_READER | getRoleName}}</option>
        </select>
      </div>

      <b-button :to="{name: 'user_info', params: {userId: userId}}">Cancel</b-button>
      <b-button type="submit" variant="primary">Save</b-button>
    </form>
  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { ROLE_ADMIN     } from '../util';
import { ROLE_MODERATOR } from '../util';
import { ROLE_READER    } from '../util';

export default {
  name: 'UserEdit',

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    const actor = auth.getViewer();
    const user = (this.userId === actor.id) ? getActorCopy(actor) : null;

    return {
      ROLE_ADMIN,
      ROLE_MODERATOR,
      ROLE_READER,

      user: user,
    };
  },

  created() {
    if(this.user === null) {
      this.loadUser();
    }
  },

  methods: {
    loadUser() {
      this.isLoading = true;

      const url = `/user/${this.userId}/info_for_editor`;
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.user = data;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    save() {
      notifier.deleteSenderNotifications(this);

      const trimmedFirstName = this.user.firstName.trim();
      if(trimmedFirstName.length === 0) {
        notifier.showError(
          'First name must be specified.',
          {sender: this}
        );
        return;
      }

      const trimmedLastName = this.user.lastName.trim();
      if(trimmedLastName.length === 0) {
        notifier.showError(
          'Last name must be specified.',
          {sender: this}
        );
        return;
      }

      const trimmedLogin = this.user.login.trim();
      if(trimmedLogin.length === 0) {
        notifier.showError(
          'Login must be specified.',
          {sender: this}
        );
        return;
      }

      const firstName = trimmedFirstName;
      const lastName = trimmedLastName;
      const login = trimmedLogin;
      const role = this.user.role;

      const data = new FormData();
      data.append('first_name', firstName);
      data.append('last_name', lastName);
      data.append('login', login);
      data.append('role', role);

      const url = `/user/${this.userId}`;
      HTTP.post(url, data)
      .then(() => {
        const actor = auth.getViewer();
        if(this.userId === actor.id) {
          actor.firstName = firstName;
          actor.lastName = lastName;
          actor.login = login;
          actor.role = role;
        } else {
          const newUserData = {
            id: this.userId,
            firstName: firstName,
            lastName: lastName,
            login: login,
            role: role,
          };
          this.$emit('user-data-updated', newUserData);
        }
        
        notifier.showSuccessAfterTransition('Changes saved.');
        this.$router.push({name: 'user_info', params: {userId: this.userId}});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};

function getActorCopy(actor) {
  return {
    id:        actor.id,
    firstName: actor.firstName,
    lastName:  actor.lastName,
    login:     actor.login,
    role:      actor.role,
  };
}
</script>
